import { Component, OnInit, Input } from '@angular/core';
import { TableComponent } from "app/components/common/table/table.component";
import {RestService} from "../../../../services/rest.service";
import {TableSelect} from "../table-select";



@Component({
    selector: 'app-table-select',
    templateUrl: './table-select.component.html',
    styleUrls: ['./table-select.component.css']
})
export class TableSelectComponent implements OnInit, TableSelect {

    @Input()
    public label: string;

    @Input()
    public options: Array<any>;

    @Input()
    public action: (obj: any) => any;

    @Input()
    public conditional?: (obj: any) => boolean;

    @Input()
    public property?: string;

    @Input()
    public defaultIndex?: any;

    constructor(private tableComponent: TableComponent,
                private _rest: RestService) {

    }

    ngOnInit() {
        this.tableComponent.addSelect(this);
    }
}
